<template>
    <div>
        <v-container>
            <v-row>
                <v-col>
                    <h1 class="text-center">Trust Partner</h1>
                    <div class="line"></div>
                    <v-container>
                        <v-row align="center" justify="center">
                            <!-- <v-col class="col-content">
                                <v-img src="https://assets.invisee.com/statis/revamp/trust/blu_by_bca_digital.png" max-width="290px" max-height="115px"
                                    contain class="marginauto"/>
                            </v-col> -->
                            <v-col class="col-content" md="4">
                                <v-img src="https://assets.invisee.com/statis/revamp/trust/bank_muamalat.png" max-width="290px" max-height="115px"
                                    contain class="marginauto"/>
                            </v-col>
                            <!-- <v-col class="col-content">
                                <v-img src="https://assets.invisee.com/statis/revamp/trust/logo_alami.png" max-width="290px" max-height="115px"
                                    contain class="marginauto"/>
                            </v-col> -->
                            <!-- <v-col class="col-content" md="3">
                                <v-img src="https://assets.invisee.com/statis/revamp/trust/bakul.png" max-width="290px" max-height="115px"
                                    contain class="marginauto"/>
                            </v-col> -->
                            <v-col class="col-content" md="4">
                                <v-img src="/miraeasset.jpg" max-width="290px" max-height="115px"
                                    contain class="marginauto"/>
                            </v-col>
                            <v-col class="col-content" md="4">
                                <v-img src="https://assets.invisee.com/statis/logo-kb-valbury-sekuritas.png" max-width="290px" max-height="115px"
                                    contain class="marginauto"/>
                            </v-col>
                            <!-- <v-col class="col-content">
                                <v-img src="https://assets.invisee.com/statis/trust/moneesa.jpg" max-height="75" max-width="170"
                                    contain class="marginauto"/>
                            </v-col>
                            <v-col class="col-content">
                                <v-img src="https://assets.invisee.com/statis/trust/rizkanna.jpg" max-height="75" max-width="170"
                                    contain class="marginauto"/>
                            </v-col> -->
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
    }
</script>

<style scoped>
    
</style>